module.exports = __webpack_public_path__ + "static/media/quora-wordmark.b50ee6b0.svg";